import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangsmith = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 33,
	fill: "none",
	viewBox: "0 0 33 33",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 33,
		height: 33,
		fill: "#11272B",
		rx: 5
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "M17.908 9.283a4.107 4.107 0 0 1 5.809 5.808l-3.831 3.831a4.073 4.073 0 0 1-5.816-.003.719.719 0 0 1 1.027-1.006 2.635 2.635 0 0 0 3.765 0l.005-.005 3.833-3.833a2.67 2.67 0 1 0-3.775-3.775l-.48.479a.719.719 0 0 1-1.016-1.017zm-4.794 4.794a4.073 4.073 0 0 1 5.816.003.719.719 0 0 1-1.027 1.006 2.636 2.636 0 0 0-3.765 0l-.005.005-3.833 3.834a2.67 2.67 0 0 0 3.775 3.775l.48-.48a.719.719 0 1 1 1.016 1.017l-.48.48a4.107 4.107 0 1 1-5.808-5.809z",
		clipRule: "evenodd"
	})]
});
export default SvgLangsmith;
